// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perfil-container {
  display: flex;
  height: 100vh;
  font-family: "Poppins", sans-serif;
  color: var(--cor-preto);
}
  
  /*  Lado esquerdo */
  .perfil-esquerda {
    width: 30%;
    height: 100vh;
    background-color: var(--cor-cinzaPerfil); 
    display: flex;
    flex-direction: column;
    position: fixed;
    gap: 20px;
  }

  .perfil-esquerda h2 {
    font-size: 180%;
    margin-top: 18px;
    text-align: center;
    width: 100%;
    font-weight: 600;
  }

  .progresso-XP {
    margin-top: 85px;
  }


  .meu-ranking {
    margin-top: 20px;
  }
  
  /*  Lado direito */
  .perfil-direita {
    background-color: var(--cor-branco);
    display: flex;
    flex-direction: column;
    width: 70%;
    height: 100vh;
    margin-left: 30vw; 
    
  }
  
  /* Seções da direita */
  .favoritos,
  .medalhas {
    margin-top: 2%;
    margin-left: 3%;
    padding-bottom: 20px;  
  }
  
  .favoritos h2,
  .medalhas h2 {
    font-size: 22px;
    color: var(--cor-pretoForte);
    margin-bottom: 1rem;
    font-weight: normal;
  }

  .perfil-titulo h1{
      font-weight: bold;
      color: var(--cor-pretoForte);
      font-family: "Roboto";
      font-size: 22px;
      margin-top: 30px;
      margin-bottom: 20px;
      margin-left: 25px;
  }

`, "",{"version":3,"sources":["webpack://./src/paginas/aluno/PerfilAluno.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,uBAAuB;AACzB;;EAEE,mBAAmB;EACnB;IACE,UAAU;IACV,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,iBAAiB;;EAEnB;;EAEA,sBAAsB;EACtB;;IAEE,cAAc;IACd,eAAe;IACf,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;MACI,iBAAiB;MACjB,4BAA4B;MAC5B,qBAAqB;MACrB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;EACrB","sourcesContent":[".perfil-container {\n  display: flex;\n  height: 100vh;\n  font-family: \"Poppins\", sans-serif;\n  color: var(--cor-preto);\n}\n  \n  /*  Lado esquerdo */\n  .perfil-esquerda {\n    width: 30%;\n    height: 100vh;\n    background-color: var(--cor-cinzaPerfil); \n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    gap: 20px;\n  }\n\n  .perfil-esquerda h2 {\n    font-size: 180%;\n    margin-top: 18px;\n    text-align: center;\n    width: 100%;\n    font-weight: 600;\n  }\n\n  .progresso-XP {\n    margin-top: 85px;\n  }\n\n\n  .meu-ranking {\n    margin-top: 20px;\n  }\n  \n  /*  Lado direito */\n  .perfil-direita {\n    background-color: var(--cor-branco);\n    display: flex;\n    flex-direction: column;\n    width: 70%;\n    height: 100vh;\n    margin-left: 30vw; \n    \n  }\n  \n  /* Seções da direita */\n  .favoritos,\n  .medalhas {\n    margin-top: 2%;\n    margin-left: 3%;\n    padding-bottom: 20px;  \n  }\n  \n  .favoritos h2,\n  .medalhas h2 {\n    font-size: 22px;\n    color: var(--cor-pretoForte);\n    margin-bottom: 1rem;\n    font-weight: normal;\n  }\n\n  .perfil-titulo h1{\n      font-weight: bold;\n      color: var(--cor-pretoForte);\n      font-family: \"Roboto\";\n      font-size: 22px;\n      margin-top: 30px;\n      margin-bottom: 20px;\n      margin-left: 25px;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
